import { adminBrokerAccount, brokerConnections } from '../data/mockData';

function BrokersPage() {
  return (
    <section className="panel-section two-column">
      <div className="table-card">
        <div className="card-header">
          <div>
            <p className="eyebrow">Section 2</p>
            <h4>Broker Authentication</h4>
            <p>User-wise Fyers connection details and admin actions.</p>
          </div>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Fyers Client ID</th>
                <th>Redirect URL</th>
                <th>Token Status</th>
                <th>Token Expiry</th>
                <th>Last Authentication</th>
                <th>Admin Actions</th>
              </tr>
            </thead>
            <tbody>
              {brokerConnections.map((connection) => (
                <tr key={connection.id}>
                  <td>{connection.user}</td>
                  <td>{connection.clientId}</td>
                  <td>{connection.redirectUrl}</td>
                  <td>
                    <span
                      className={`status-pill ${connection.tokenStatus
                        .toLowerCase()
                        .replace(/\s+/g, '-')}`}
                    >
                      {connection.tokenStatus}
                    </span>
                  </td>
                  <td>{connection.tokenExpiry}</td>
                  <td>{connection.lastAuthentication}</td>
                  <td>
                    <div className="action-group">
                      <button type="button" className="ghost-button compact">
                        Revoke Token
                      </button>
                      <button type="button" className="ghost-button compact">
                        Re-Auth
                      </button>
                      <button type="button" className="ghost-button compact">
                        Check Status
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="stack-column">
        <article className="info-card">
          <p className="eyebrow">Internal Data Account</p>
          <h4>Admin Fyers connection</h4>
          <ul className="meta-list">
            <li>
              <span>Admin Client ID</span>
              <strong>{adminBrokerAccount.clientId}</strong>
            </li>
            <li>
              <span>Token Status</span>
              <strong>{adminBrokerAccount.tokenStatus}</strong>
            </li>
            <li>
              <span>Token Expiry</span>
              <strong>{adminBrokerAccount.tokenExpiry}</strong>
            </li>
            <li>
              <span>Last Refresh</span>
              <strong>{adminBrokerAccount.lastRefresh}</strong>
            </li>
          </ul>
          <div className="action-group">
            <button type="button" className="primary-button compact">
              Refresh Token
            </button>
            <button type="button" className="ghost-button compact">
              Reconnect Broker
            </button>
          </div>
        </article>

        <article className="info-card">
          <p className="eyebrow">Broker Form</p>
          <h4>Client ID placeholder</h4>
          <label className="inline-form">
            Fyers Client ID
            <input type="text" placeholder="Enter client ID" />
          </label>
          <button type="button" className="ghost-button compact">
            Save Placeholder
          </button>
        </article>
      </div>
    </section>
  );
}

export default BrokersPage;
